import React from 'react'
import { Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { headerStyle } from './OnboardingHeader.styles'
import { useTranslation } from 'react-i18next'

type OnboardingHeaderProps = {
	i18nHeader: string
}

export default function OnboardingHeader({ i18nHeader }: OnboardingHeaderProps) {
	const { palette } = useTheme()
	const { t } = useTranslation()
	return <Typography sx={headerStyle(palette)}>{t(i18nHeader)}</Typography>
}
